var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "timeslot-item__table --mobile" }, [
    _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "guest-label", attrs: { colspan: "2" } }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.tc("spaSoft.step1.guestTimeDateSelection.guestFieldLabel", {
                  guestNumber: _vm.index + 1,
                })
              ) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _vm._l(_vm.guestData.itinerary, function (itinerary, i) {
          return [
            _c("tr", { key: "time-" + i }, [
              _c("td", { staticClass: "time", attrs: { rowspan: "4" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.getStartEndLabel(itinerary.start, itinerary.end)
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.getTreatmentName({
                      guestNumber: _vm.index,
                      itinerary: itinerary,
                    })
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", { key: "duration-" + i }, [
              _c("td", { staticClass: "grey-brown" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.getTreatmentDuration({
                        guestNumber: _vm.index,
                        itinerary: itinerary,
                      })
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", { key: "gender-" + i }, [
              _c("td", { staticClass: "grey-brown" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.getGenderPreference({
                        guestNumber: _vm.index,
                        itinerary: itinerary,
                      })
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", { key: "price-" + i }, [
              _c("td", { staticClass: "grey-brown price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.getPriceWithIsoCode({
                        guestNumber: _vm.index,
                        itinerary: itinerary,
                      })
                    ) +
                    "\n        "
                ),
              ]),
            ]),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }